import { createClient } from '@supabase/supabase-js';
import toast from 'react-hot-toast';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Debug environment variables
console.log('Supabase configuration check:');
console.log('URL exists:', !!supabaseUrl);
console.log('Key exists:', !!supabaseAnonKey);
console.log('URL format valid:', supabaseUrl?.startsWith('https://'));

if (!supabaseUrl || !supabaseAnonKey) {
  const missing = [];
  if (!supabaseUrl) missing.push('VITE_SUPABASE_URL');
  if (!supabaseAnonKey) missing.push('VITE_SUPABASE_ANON_KEY');
  throw new Error(`Missing Supabase environment variables: ${missing.join(', ')}`);
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web',
    },
  },
});

export const handleError = (error: any, customMessage?: string) => {
  console.error('Error:', error);
  
  if (error.code === 'PGRST301') {
    toast.error('Sua sessão expirou. Por favor, faça login novamente.');
    supabase.auth.signOut();
    return;
  }

  if (error.code === '23505') {
    toast.error('Este registro já existe.');
    return;
  }

  if (error.code === '23503') {
    toast.error('Não foi possível realizar esta operação pois existem registros dependentes.');
    return;
  }

  toast.error(customMessage || 'Ocorreu um erro. Por favor, tente novamente.');
};